import React, { useEffect, useState } from "react";
import { getUserProfile } from "../../utilities/axios.utilities";
import { getAssetUrl } from "../../utils/assetUrl";
import ModalConfirmLogout from "../ModalConfirmLogout";
import "./ThnShell.css";

type ThnShellProps = {
  children: React.ReactNode;
};

function formatToken(n: number | undefined): string {
  if (n == null || Number.isNaN(n)) return "0";
  return n.toLocaleString("vi-VN");
}

export default function ThnShell({ children }: ThnShellProps) {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        let prev: Record<string, unknown> = {};
        try {
          prev = JSON.parse(localStorage.getItem("user_info") || "{}");
        } catch {
          prev = {};
        }
        localStorage.setItem(
          "user_info",
          JSON.stringify({
            ...prev,
            userName: data.username,
            coins: data.coins,
            role: data.role,
            id: data._id ?? prev.id,
          })
        );
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };
    fetchProfile();
  }, []);

  const userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
  const displayName = userProfile?.username ?? userInfo?.userName ?? "User";
  const coins = Number(userProfile?.coins ?? userInfo?.coins ?? 0);

  return (
    <div className="thn-app">
      <header className="thn-header">
        <div className="thn-header__left">
          <span className="thn-header__dot" />
          <span className="thn-header__sys">SYS.ONLINE</span>
          <span className="thn-header__sep">•</span>
          <span className="thn-header__chan">KÊNH BẢO MẬT</span>
        </div>
        <div className="thn-header__right">
          <div className="thn-chip thn-chip--user">
            <img
              src={getAssetUrl("/assets/thn/icon-header-user.svg")}
              alt=""
              width={20}
              height={20}
            />
            <span>{displayName}</span>
          </div>
          <div className="thn-chip thn-chip--coin">
            <img src={getAssetUrl("/assets/thn/icon-coin.svg")} alt="" width={13} height={13} />
            <span>{formatToken(coins)} điểm</span>
          </div>
          <button
            type="button"
            className="thn-chip thn-chip--logout"
            onClick={() => setIsShowLogout(true)}
          >
            Đăng xuất
          </button>
        </div>
      </header>

      <div className="thn-app__body">{children}</div>

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
}
